import { useCountUp } from './useCountUp';
import styles from './CountUp.module.css';

export function CountUp({ value, format }: { value: number; format: (n: number) => string }) {
  const ref = useCountUp<HTMLSpanElement>(value, format);
  return <span ref={ref} className={styles.countUp}>{format(value)}</span>;
}
